import './SelectFilter.css';

const LevelBadge = ({ requiredLevel, userLevel, isLoggedIn }) => {
  if (!isLoggedIn) {
    return <span className="level-badge login-required">Login Required</span>;
  }
  if (userLevel < requiredLevel) {
    return <span className="level-badge">Level {requiredLevel}+</span>;
  }
  return null;
};

const SelectFilter = ({ 
  label, 
  value, 
  onChange, 
  options,
  disabled = false,
  requiredLevel,
  userLevel,
  isLoggedIn
}) => {
  return (
    <div className="filter-group">
      <label>
        <span>{label}</span>
        {requiredLevel !== undefined && (
          <LevelBadge requiredLevel={requiredLevel} userLevel={userLevel} isLoggedIn={isLoggedIn} />
        )}
      </label>
      <select value={value} onChange={onChange} disabled={disabled}>
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SelectFilter;
